
import { Vue, Component, Prop } from "vue-property-decorator";
import { InsuredInformationVO } from "@fubonlife/tacallindiy-core-axios-sdk";

@Component
export default class InsuredDetailModal extends Vue {

	@Prop()
	insuredInfos: InsuredInformationVO[];

	activeKey = [];

	productName = {
		add: "富邦人壽快易保新旅行平安保險",
		mr: "富邦人壽快易保旅行平安保險傷害醫療保險附約",
		nohs: "富邦人壽快易保旅行平安保險海外突發疾病醫療健康保險附約",
		mrc: "富邦人壽快易保兒童傷害醫療旅行平安保險"
	}
	productRemark = "針對未滿十五足歲之被保險人，本保險契約不含身故之喪葬費用保險金給付。";

	get getTotalFee(){
		return this.insuredInfos.map(e=>parseInt(e.fee)).reduce((next,current)=>next+current,0);
	}

	get getHasUnder15Insured(){
		return this.insuredInfos.findIndex(e=> e.age < 15) !== -1
	}

	// 取得身分證末三碼
	getInsuredLast3Text(insuredId: string) {
		if (insuredId) {
			return insuredId.slice(insuredId.length - 3, insuredId.length)
		} else {
			return "";
		}
	}
}
